enum AccessType {
    PU_O_APPRQ = 'PU_O_APPRQ',
    PU_O_APP = 'PU_O_APP',
}

export default AccessType;